import { Paper, Text } from '@mantine/core';

export interface KpiApi {
  rotulo: string;
  valor: string;
  delta?: string | null;
  /** Variação sem sinal de bom/ruim (ex.: "primeira coleta"): fica em cinza. */
  neutro?: boolean;
  /** Queda é boa (ex.: desvio): vermelho para alta, verde para queda (`delta_color="inverse"`). */
  inverso?: boolean;
  /** Explicação curta abaixo do valor (o `help` do st.metric do legado). */
  ajuda?: string | null;
}

export function Kpi({ kpi }: { kpi: KpiApi }) {
  const queda = kpi.delta?.trim().startsWith('-');
  const cor = kpi.neutro ? 'dimmed' : queda !== !!kpi.inverso ? 'red' : 'teal';
  return (
    <Paper withBorder p="md" radius="md">
      <Text size="sm" c="dimmed">
        {kpi.rotulo}
      </Text>
      <Text size="xl" fw={600}>
        {kpi.valor}
      </Text>
      {kpi.delta && (
        <Text size="sm" c={cor}>
          {kpi.delta}
        </Text>
      )}
      {kpi.ajuda && (
        <Text size="xs" c="dimmed" mt={4}>
          {kpi.ajuda}
        </Text>
      )}
    </Paper>
  );
}
